var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSwissFlag = function SvgSwissFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.994,
    height: 63,
    viewBox: "0 0 62.994 63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 167"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 23",
    d: "M31.497 0a31.5 31.5 0 1031.5 31.5A31.5 31.5 0 0031.497 0zm.081 58.17h-.161a26.676 26.676 0 01-.03-53.351h.222a26.676 26.676 0 01-.03 53.351z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 24",
    d: "M31.61 4.356h-.226a27.14 27.14 0 00.031 54.279h.164a27.14 27.14 0 00.031-54.279zm16.843 32.229H36.585v11.868H26.399V36.585H14.532V26.41h11.867V14.537h10.186V26.41h11.867z",
    fill: "#c72127"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 25",
    d: "M36.926 13.401H26.059V26.07H13.397v10.857h12.662V49.59h10.868V36.926h12.657V26.07H36.926z",
    fill: "#fff"
  }))));
};
export default SvgSwissFlag;